import setSummary from "components/Orders/getOrderDetails";
import { ApiRequest, ShowLoader } from "GlobalFunctions";
import { validateLogic } from "../../../utils/logicValidator";
import { calculateTaxes } from "../../Orders/CalculateTaxes";

// Store the shipping model globally for reuse
let globalShippingModel: HTMLElement | null = null;

/*========================================================
GET SHIPPING METHODS
=========================================================*/
export const getShippingMethods = async () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');

    if(!cart.client || !cart.client.s_country || !cart.client.s_state || !cart.client.s_city_id) {
        await mapShippingMethods([]);
        return;
    }


    await ApiRequest({
        url: '/shipping/zones/getStoreShipping',
        method: 'POST',
        body: {
            cart
        },
        setResponse: async (response: any) => {
            await mapShippingMethods(response);
            if (response.length === 0) {
            }
            
        }
    });
}

/*========================================================
MAP SHIPPING METHODS
=========================================================*/
export const mapShippingMethods = async (shippingMethods: any) => {
    // Disable same-as checkbox during mapping process
    const sameAsCheckbox = document.querySelector('input[pc="same-as"]') as HTMLInputElement;
    if (sameAsCheckbox) {
        sameAsCheckbox.disabled = true;
    }

    const cart = JSON.parse(localStorage.getItem('cart') || '{}');
    const shipping = cart.shipping;
    
    // Check if shipping exists and has a valid shipping_id
    if (shipping) {
        // Remove shipping property if shipping_id is 0 or doesn't exist
        delete cart.shipping;
        cart.shipping_price = 0;
        localStorage.setItem('cart', JSON.stringify(cart));
    }
    
    /* LOGIC VALIDATOR
    =========================================================*/
    let adjustedShippingMethods = [...shippingMethods];
    try {
        const logicResult = await validateLogic({cart, logicMethod: 'shipping'});
        if (logicResult && logicResult.shippingLogic && logicResult.shippingLogic.length > 0) {
            for (const logic of logicResult.shippingLogic) {
                if (logic.addToAll) {
                    adjustedShippingMethods = adjustedShippingMethods.map((m) => ({ ...m, price: parseFloat(logic.price) }));
                } else if (logic.shippingMethods && logic.shippingMethods.length > 0) {
                    adjustedShippingMethods = adjustedShippingMethods.map((m) => {
                        const found = logic.shippingMethods.find((sm: any) => sm.shipping_id === m.shipping_id && sm.price !== undefined && sm.price !== "");
                        if (found) {
                            return { ...m, price: parseFloat(found.price) };
                        }
                        return m;
                    });
                }
            }
        }
    } catch (e) {
        console.error('Error applying shipping logic:', e);
    }

    // Store updated shipping methods in localStorage
    localStorage.setItem('shippingMethods', JSON.stringify(adjustedShippingMethods));

    const container = document.querySelector('[pc="shipping-wrapper"]');
    
    // Set globalShippingModel if not already set
    if (!globalShippingModel) {
        const shippingModelHtml = document.querySelector('[pc="shipping-item"]');
        if (shippingModelHtml) {
            globalShippingModel = shippingModelHtml.cloneNode(true) as HTMLElement;
            globalShippingModel.classList.remove('is-active');
        }
    }

    if (globalShippingModel && container) {
        const shippingModel = globalShippingModel;

        container.innerHTML = '';

        /* MAP SHIPPING METHODS
        =========================================================*/
        for (let method of adjustedShippingMethods) {
            let shippingMethod = shippingModel.cloneNode(true) as HTMLElement;

            /*LABEL
            =========================================================*/
            const shippingLabel = shippingMethod.querySelector('[pc="shipping-label"]') as HTMLElement;
            if (shippingLabel) {
                shippingLabel.textContent = method.rate_name; 
            }

            /*RADIO BUTTON
            =========================================================*/
            const shippingRadio = shippingMethod.querySelector('[pc="shipping-radio"]') as HTMLInputElement;
            if (shippingRadio) {
                shippingRadio.setAttribute('value', method.shipping_id.toString());
            }

            /*PRICE
            =========================================================*/
            const price = method.price === 0 ? 'Free' : '$' + parseFloat(method.price).toLocaleString();
            const shippingPrice = shippingMethod.querySelector('[pc="shipping-price"]') as HTMLElement;
            if (shippingPrice) {
                shippingPrice.textContent = price;
            }

            /*LISTENERS
            =========================================================*/
            // El listener se añade después de preseleccionar el método
            shippingRadio.addEventListener('change', async () => {
                // Agregar clase activa al método de envío seleccionado
                document.querySelectorAll('[pc="shipping-item"]').forEach((element) => {
                    element.classList.remove('is-active');
                });
                shippingMethod.classList.add('is-active');

                // Actualizar el método de envío
                await updateShippingMethod(method);
            });

            container.appendChild(shippingMethod);
        }

        if (shippingMethods.length === 0) {
            container.innerHTML = 'No shipping methods available';
        }
    }

    // Re-enable same-as checkbox after mapping process is complete
    if (sameAsCheckbox) {
        sameAsCheckbox.disabled = false;
    }

    ShowLoader(false);
}

const updateShippingMethod = async (shipping: any) => {
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');
    cart.shipping = shipping;
    cart.shipping_price = Number(shipping.price);
    localStorage.setItem('cart', JSON.stringify(cart));
    await calculateTaxes(cart);
}

/*=========================================================
FUNCTIONS TO BE CALLED /  CUSTOM CODE
=========================================================*/
(window as any).mapShippingMethods = mapShippingMethods;



